import React, { useEffect } from "react";

type ProviderProps = {
  children: React.ReactNode;
};

const AppContext = React.createContext<{ isProd: boolean }>({
  isProd: false,
});

export const AppProvider = ({ children }: ProviderProps) => {
  const [isProd, setIsProd] = React.useState<boolean>(false);
  useEffect(() => {
    setIsProd(!!+(process.env.GATSBY_IS_PROD || false));
  }, []);

  return (
    <AppContext.Provider value={{ isProd }}>{children}</AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = React.useContext(AppContext);
  if (!context)
    throw new Error("useAppContext must be used within an AppProvider");
  return context;
};
